import React, { useState } from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa'
import './faqs.css'

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: 'WHAT IS LILPEPE?',
      answer: 'Lilpepe is a fictional token created for demonstration purposes.'
    },
    {
      question: 'IS LILPEPE A REAL TOKEN?',
      answer: 'No, Lipepe is not a real token; it’s used here as an example.'
    },
    {
      question: 'WHAT IS THE TOTAL SUPPLY OF LILPEPE?',
      answer: 'The total supply of Lipepe is 1,000,000 tokens.'
    },
    {
      question: 'WHAT IS THE CURRENT PRICE OF LILPEPE?',
      answer:
        'The current price of Lipepe is $0.001 as of 07:59 PM +06 on June 17, 2025.'
    },
    {
      question: 'WHAT IS THE NEXT STAGE PRICE OF LILPEPE?',
      answer: 'The next stage price of Lipepe is projected to be $0.0012'
    }
  ]

  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="faqs-container" id="faq">
      <div className=" max-w-7xl mx-auto">
        <h3 className="faqs-title">Frequently asked questions</h3>
        <div className="faq-items">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                {faq.question}
                <span className="faq-icon-cont">
                  {openIndex === index ? (
                    <FaMinus className="faq-icon" fill="#000000" />
                  ) : (
                    <FaPlus className="faq-icon" fill="#000000" />
                  )}
                </span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Faqs
